import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Fab, Tooltip, Zoom } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function ScrollToTop() {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Zoom in={isVisible}>
      <Tooltip title="Scroll to top" placement="left" arrow>
        <Fab
          color="secondary"
          size="medium"
          onClick={handleClick}
          aria-label="Scroll to top of page"
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1200,
            boxShadow: 3,
            '&:hover': {
              transform: 'scale(1.08)',
            },
            '&:focus-visible': {
              outline: (theme) => `3px solid ${theme.palette.primary.main}`,
              outlineOffset: '3px',
              transform: 'scale(1.08)',
            },
            transition: 'transform 0.2s ease-in-out',
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Tooltip>
    </Zoom>
  );
}

export default ScrollToTop;
